export default __webpack_public_path__ + "static/media/gray-star.7be5f61b.svg";